import { Provider } from '@angular/core';
import { ModelEventBus } from '@web-portal/domains/shared/event-bus';

export function provideModelsDomain(): Provider[] {
  return [ModelEventBus];
}
